import React, { useEffect } from 'react'
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";


// components
import FbProjectList from "./_list";
import FbProjectForm from "./_form";
import { showLoader } from "../../../components/loader/loader";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";

// actions
import { clearState, setApp, setCategory, setLoading, setUdn, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { setForm } from "../../../redux/actions/generalActions/formActions";
import { ADD_STATE,
    REMOVE_STATE, } from "../../../redux/actions/generics/IndexedActions";
import { ButtonNew } from "../../../components/buttons/buttonsActions";

const FbProject = props => {
    const path = 'config/fbProject';
    const { loading } = props.mainProps


    // limpia el state
    useEffect(() => {
        return () => {
            props.clearState();
        }
    }, []);


    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);


    const createItem = () => {
        props.setForm()
        ModalFormContainer(FbProjectForm, {data : null, Form: FbProjectForm})
    }


    return <>
        { loading && showLoader() }

        <Row>
            <Col md="12">
                <div className="d-flex align-items-center">
                    <div className="ml-auto paddingAdd">
                        <ButtonNew onClick={createItem} />
                    </div>
                </div>
            </Col>
            <Col>
                <FbProjectList path={path} />
            </Col>
        </Row>
    </>
}


const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    ADD_STATE,
    REMOVE_STATE,
});

export default connect(mapStateToProps, mapActionsToProps)(FbProject)